<template>
  <div class="mb-3">
    <custom-callout border-color="secondary-2" :has-toggle="false">
      <div class="row mt-3">
        <div class="col-md-3 col-12">
          <div class="color-secondary-6 font-14">
            Nombre:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.name | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="color-secondary-6 font-14">
            Puesto:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.chargeName | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="color-secondary-6 font-14">
            Tipo de Participación:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.participantType?.name | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14">
            Área:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.area | empty }}
          </div>
        </div>
        <div
          v-if="!isReadonly"
          class="col-md-1 col-12 d-flex justify-content-md-end justify-content-start"
        >
          <action-button
            class="mr-2 px-3"
            i="fas fa-times-circle"
            text=""
            variant="outline-danger"
            @click="remove"
          />
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import alertMixin from '@/mixins/alert.mixin.js';
import ActionButton from 'ActionButton';

export default {
  name: 'ParticipantSignatureRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    actionItems() {
      return [
        {
          label: 'Generar Carta',
          icon: 'fas fa-file-alt text-green ',
          click: this.generateLetter,
          visible: this.userHasPermissions(
            'provider.competitionprocess.generateletter.view'
          ),
        },
        {
          label: 'Ver Propuestas',
          icon: 'fas fa-file-import text-green',
          visible: this.showProposals,
          click: this.emitView,
        },
      ];
    },
  },
  async mounted() {},
  methods: {
    remove() {
      this.$emit('delete');
    },
  },
};
</script>

<style scoped lang="scss"></style>
